import {App_Conf} from "./app_conf";
import {SpaConfigBase, SpaConfigHttpResponse, SpaConfigKeyVault, SpaConfigMeetingPortal} from "./models/SpaConfig";
import {clientManagementApiClient} from "../ClientManagement/ClientManagementApiClient";
import configApiClient from "./configApiClient";
import {meetingPortalAuthenticatorClient} from "../ClientManagement/Meeting/MeetingPortalAuthenticatorClient";

export const getSpaConfigBase = async (): Promise<SpaConfigBase> => {
    return {
        clientId: App_Conf.SPA_CONFIG_CLIENT_ID,
        scopes: App_Conf.SPA_CONFIG_SCOPES,
    };
};

export const getSpaConfigFunctionApp = async (): Promise<SpaConfigHttpResponse> => {
    const response = await configApiClient.getSpaConfig();
    return {
        relayTenantId: response.relayTenantId,
    };
};

export const getSpaConfigMeetingPortal = async (): Promise<SpaConfigMeetingPortal> => {
    const response = await meetingPortalAuthenticatorClient.getMeetingInfo();
    return {
        relayTenantId: response.relayTenantId,
    };
};

export const getSpaConfigKeyVault = async (): Promise<SpaConfigKeyVault> => {
    const response = await clientManagementApiClient.getSpaConfigFromKeyVault();
    return {
        appInsightInstrumentationId: response.appInsightInstrumentationId,
        relayTenantId: response.relayTenantId,
    };
};